import React, { useEffect, useRef } from 'react';
import CodeMirror from 'codemirror';
import 'codemirror/mode/stex/stex';
import 'codemirror/lib/codemirror.css';

// Thin CodeMirror 5 wrapper for editing LaTeX source (stex mode). Kept local and dependency-light
// on purpose — the React 16 / react-scripts 3.2 stack is fragile, so we avoid react-codemirror2.
interface Props {
  value: string;
  onChange: (value: string) => void;
}

const CodeMirrorEditor: React.FC<Props> = ({ value, onChange }) => {
  const taRef = useRef<HTMLTextAreaElement>(null);
  const cmRef = useRef<any>(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  // Initialise once.
  useEffect(() => {
    if (!taRef.current) return;
    const cm = CodeMirror.fromTextArea(taRef.current, {
      mode: 'stex',
      lineNumbers: true,
      lineWrapping: true,
      tabSize: 2,
      viewportMargin: Infinity,
    });
    cm.setSize('100%', '100%');
    cm.on('change', (inst: any) => onChangeRef.current(inst.getValue()));
    cmRef.current = cm;
    return () => { cm.toTextArea(); cmRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Sync external value changes (e.g. a document loaded from the API) without clobbering the cursor.
  useEffect(() => {
    const cm = cmRef.current;
    if (cm && value !== cm.getValue()) cm.setValue(value);
  }, [value]);

  return (
    <div style={{ height: '100%', border: '1px solid #ccc' }}>
      <textarea ref={taRef} defaultValue={value} />
    </div>
  );
};

export default CodeMirrorEditor;
